<template>
    <div class="ben-wrapper">
        <div class="statistics-head">
            <div class="month-count">
                <span>{{ statistics.bycb || 0 }}</span>
                <p>本月单位成本(元/方)</p>
            </div>
            <div class="year-count">
                <span>{{ statistics.bncb || 0 }}</span>
                <p>本年累计单位成本(元/方)</p>
            </div>
        </div>
        <div class="chart-item">
            <p>直接材料成本</p>
            <div id="chart1" class="chart-wrapper"></div>
        </div>
        <div class="chart-item">
            <p>制造费用</p>
            <div id="chart2" class="chart-wrapper"></div>
        </div>
        <div class="chart-item">
            <p>其他费用</p>
            <div id="chart3" class="chart-wrapper"></div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            chartData1: [],
            chartData2: [],
            chartData3: [],
            Year: '',
            Month: '',
            statistics: {},
        };
    },
    created() {
        this.Year = new Date().getFullYear();
        this.Month = new Date().getMonth() + 1;
    },
    mounted() {
        this.getTotal();
        this.getStatistics(0);
        this.getStatistics(1);
        this.getStatistics(2);
    },
    methods: {
        getTotal() {
            this.$axios
                .get('/interfaceApi/report/largescreen/sccb/tj/' + this.Year + '/' + this.Month + '/0')
                .then(res => {
                    this.statistics = res;
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        getStatistics(type) {
            this.$axios
                .get('/interfaceApi/report/largescreen/sccb/fl/' + this.Year + '/' + this.Month + '/0?flbm=' + type)
                .then(res => {
                    if (type === 0) {
                        this.chartData1 = res;
                        this.chart1();
                    } else if (type === 1) {
                        this.chartData2 = res;
                        this.chart2();
                    } else {
                        this.chartData3 = res;
                        this.chart3();
                    }
                })
                .catch(error => {
                    Toast.fail('message:' + error.ErrorCode.Message + '');
                });
        },
        chart1() {
            const myChart = this.$echarts.init(document.getElementById('chart1'));
            const xdata = [];
            const data = [];

            this.chartData1.forEach(item => {
                xdata.push(item.yf + '月');
                data.push(item.dwcb);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '14%',
                    bottom: '12%',
                    right: '14%',
                },
                xAxis: {
                    type: 'value',
                    name: '元/方',
                    nameTextStyle: {
                        align: 'top',
                    },
                    splitNumber: 5,
                    scale: true,
                    position: 'top',
                    min: 0,
                    boundaryGap: false,
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: {
                    type: 'category',
                    nameGap: 16,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisTick: {
                        show: false,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#999',
                        },
                    },
                    data: xdata,
                },
                series: [{
                    type: 'pictorialBar',
                    stack: '',
                    symbol: 'fixed',
                    symbolSize: [10, 10],
                    symbolMargin: 1,
                    symbolRepeat: 'repeat',
                    symbolBoundingData: 400,
                    label: {
                        show: true,
                        position: 'right',
                        color: '#FA8B47',
                        fontWeight: 'bolder',
                        fontSize: 12,
                    },
                    barWidth: 10,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(239,171,84,1)', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(250,139,71,1)', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: -10,
                }],
            };
            myChart.setOption(option);
        },
        chart2() {
            const myChart = this.$echarts.init(document.getElementById('chart2'));
            const xdata = [];
            const data = [];

            this.chartData2.forEach(item => {
                xdata.push(item.yf + '月');
                data.push(item.dwcb);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '14%',
                    bottom: '12%',
                    right: '14%',
                },
                xAxis: {
                    type: 'value',
                    name: '元/方',
                    nameTextStyle: {
                        align: 'auto',
                    },
                    splitNumber: 6,
                    scale: true,
                    position: 'top',
                    min: 0,
                    boundaryGap: false,
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: {
                    type: 'category',
                    nameGap: 16,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisTick: {
                        show: false,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#999',
                        },
                    },
                    data: xdata,
                },
                series: [{
                    type: 'bar',
                    stack: '',
                    symbol: 'fixed',
                    symbolSize: [20, 10],
                    symbolMargin: 1,
                    symbolRepeat: 'repeat',
                    label: {
                        show: true,
                        position: 'right',
                        color: '#449FF3',
                        fontWeight: 'bolder',
                        fontSize: 10,
                    },
                    barWidth: 15,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(85,167,254,1)', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(62,121,197,1)', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: -10,
                }],
            };
            myChart.setOption(option);
        },
        chart3() {
            const myChart = this.$echarts.init(document.getElementById('chart3'));
            const xdata = [];
            const data = [];

            this.chartData3.forEach(item => {
                xdata.push(item.yf + '月');
                data.push(item.dwcb);
            });
            const option = {
                grid: {
                    left: '10%',
                    top: '14%',
                    bottom: '12%',
                    right: '14%',
                },
                xAxis: {
                    type: 'value',
                    name: '元/方',
                    nameTextStyle: {
                        align: 'auto',
                    },
                    splitNumber: 6,
                    scale: true,
                    position: 'top',
                    min: 0,
                    boundaryGap: false,
                    splitLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                            width: 1, // 这里是为了突出显示加上的
                        },
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999',
                            fontSize: 10,
                        },
                    },
                },
                yAxis: {
                    type: 'category',
                    nameGap: 16,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisTick: {
                        show: false,
                        lineStyle: {
                            color: '#ddd',
                        },
                    },
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            color: '#999',
                        },
                    },
                    data: xdata,
                },
                series: [{
                    type: 'bar',
                    stack: '',
                    symbol: 'fixed',
                    symbolSize: [20, 10],
                    symbolMargin: 1,
                    symbolRepeat: 'repeat',
                    label: {
                        show: true,
                        position: 'right',
                        color: '#71C6B0',
                        fontWeight: 'bolder',
                        fontSize: 10,
                    },
                    barWidth: 15,
                    itemStyle: {
                        normal: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0,
                                    color: 'rgba(113,198,176,1)', //  0%  处的颜色
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(78,164,150,1)', //  100%  处的颜色
                                },
                                ],
                                global: false, //  缺省为  false
                            },
                        },
                        emphasis: {
                            opacity: 1,
                        },
                    },
                    data: data,
                    z: -10,
                }],
            };
            myChart.setOption(option);
        },
    },
};
</script>

<style lang="stylus">
    .ben-wrapper
        // margin-top 20rpx
        .statistics-head
            background #ffffff
            display flex
            padding 15rpx
            // margin-top 15rpx
            div
                flex 1
                text-align center
                &.month-count
                    span
                        color #FA8436
                        font-size 16rpx
                &.year-count
                    span
                        color #5588F1
                        fonts-size 16rpx
                p
                    font-size 10rpx
                    color #666666
                    line-height 20rpx
        .chart-item
            padding 15rpx
            background #ffffff
            // &:last-child
            margin-top 15rpx
            p
                font-size 16rpx
                font-weight 600
                color rgba(51,51,51,1)
                line-height 36px
            .total-wrapper
                display flex
                justify-content space-between
                .total-item
                    width 150rpx
                    height 30rpx
                    border 2rpx solid rgba(234,234,234,1)
                    font-size 10rpx
                    line-height 26rpx
                    text-align center
                    span
                        font-size 12rpx
                        line-height 26rpx
                    &:first-child
                        span
                            color #4486D5
                    &:last-child
                        span
                            color #F8924A
            .chart-wrapper
                height 200rpx
                width 100%


</style>